export function getDummySurveyResponses() {
  const responses = [];
  const now = Date.now();
  for (let i = 1; i <= 55; i++) {
    const completed = i % 3 !== 0; // 2/3 completed, 1/3 partial
    responses.push({
      uid: `dummy${i}`,
      firstName: `Test${i}`,
      lastName: `User${i}`,
      email: `test${i}@example.com`,
      createdAt: { seconds: Math.floor((now - i * 86400000) / 1000) },
      lastUpdated: { seconds: Math.floor((now - i * 43200000) / 1000) },
      surveyData: completed
        ? {
            firstName: `Test${i}`,
            lastName: `User${i}`,
            email: `test${i}@example.com`,
            residencyCounty: "Dublin",
            workArrangement: "Hybrid",
            commutingFrequency: "3 days per week",
            officeLocation: "Dublin",
            primaryLocation: "Ireland",
            currentRole: "Engineer",
          }
        : {
            firstName: `Test${i}`,
            lastName: `User${i}`,
            email: `test${i}@example.com`,
          },
    });
  }
  return responses;
}
